import { QarepaEnumInformation } from '@qarepa/common';

export enum UnNameAvatarPreviewEnum {
  UNSUPERVISED = 'UNSUPERVISED',
  UNASSIGNED = 'UNASSIGNED',
}
export type UnNameAvtarPreviewType =
  UnNameAvatarPreviewEnum.UNSUPERVISED | UnNameAvatarPreviewEnum.UNASSIGNED;

export const UnNameAvatarPreviewArray = [
  UnNameAvatarPreviewEnum.UNSUPERVISED,
  UnNameAvatarPreviewEnum.UNASSIGNED,
];

export const UnNameAvatarPreviewInfo: QarepaEnumInformation<UnNameAvatarPreviewEnum> =
  {
    [UnNameAvatarPreviewEnum.UNSUPERVISED]: {
      name: $localize`No Supervisado`,
    },
    [UnNameAvatarPreviewEnum.UNASSIGNED]: {
      name: $localize`No Asignado`,
    },
  };
